// extracted by mini-css-extract-plugin
export var chip = "_bx-0";
export var filterDropdown = "_bx-5";
export var filterItem = "_bx-6";
export var icon = "_bx-1";
export var removeButton = "_bx-3";
export var removeIcon = "_bx-4";
export var separator = "_bx-2";